import request from '@/plugins/axios'

// 订单列表其他列表参数
export const apiOtherLists = () => request.get('/order.set_meal_order/searchParam')

// 订单详情
export const apiOrderDetail = (params: any) => request.get('/order.set_meal_order/detail', { params })

// 订单列表
export const apiOrderLists = (params: any) => request.get('/order.set_meal_order/lists', { params })

//商户体现
export const apiShopWithdrawLists = (params: any) => request.get('/order.shop_withdraw/lists', { params })
// 订单备注
export const apiOrderRemarks = (params: any) => request.post('/order.set_meal_order/remark', params)

// 确认支付
export const apiOrderConfirmPay = (params: any) => request.post('/order.set_meal_order/confirmPay', params)

// 订单列表
export const apiOrderListsNews = (params: any) => request.get('/order.shop_order/lists', { params })
export const apiOrderDeliveryInfo = (params: any) => request.get('/order.shop_order/deliveryInfo', { params })

export const apiDelivery = (params: any) => request.post('/order.shop_order/delivery', params)
// 物流查询
export const apiOrderLogistics = (params: any) => request.get('/order.shop_order/logistics', { params })
